import React from 'react';

export type PriceTagProps = {
  price: string;
  comparePrice?: string;
  saveAmount?: string;
};

const PriceTag: React.FC<PriceTagProps> = ({
  price,
  comparePrice,
  saveAmount,
}) => (
  <div
    className={`relative flex items-center gap-x-3 rounded-t-[7px] bg-purple-500 px-5 py-3 text-white ${
      saveAmount ? 'pr-28' : ''
    }`}
  >
    <p className="flex items-start font-semibold leading-none">
      <span className="mt-1 text-xl">$</span>
      <span className="text-5xl">{price}</span>
    </p>
    {comparePrice ? (
      <s className="text-2xl font-medium leading-none text-white/60">
        <span className="sr-only">Regular price </span>${comparePrice}
      </s>
    ) : null}
    {saveAmount ? (
      <div
        className="absolute right-5 top-0 flex w-[72px] flex-col items-center bg-[#FFD23F] px-2 pb-6 pt-2 text-black"
        style={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 76%, 0 100%)' }}
      >
        <span className="text-[11px] font-bold uppercase leading-none tracking-wider">
          Save
        </span>
        <span className="mt-1 text-xl font-bold leading-none">
          ${saveAmount}
        </span>
      </div>
    ) : null}
  </div>
);

export default PriceTag;
